import InvoicingRecipients from './InvoicingRecipients';

export default InvoicingRecipients;
